import React, { useEffect, useState } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import { Expeditor, Order } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";
import OrderBookingCard from "../../../../pages/orders/booking/OrderBookingCard";
import CloseIconNew from "../../../shared/icons/CloseIconNew";

const AssignYourDriver = ({ user, orderId, onUpdateData, fetchOrderData}) => {
  const [isBooked, setBookedState] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [getOrder, setOrder] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const fetchOrderDataById = async () => {
    setLoading(true);
    try {
      const { data } = await Order.getOrderForExpeditor({ orderId });
      setBookedState(data.isBooked);
      setOrder(data.order);
      if (data.vehicle && data.driver) {
        getBookData({
          driver: data.driver,
          transport: data.vehicle,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getBookData = ({ driver, transport }) => {
    setDrivers([
      {
        ...driver,
        vehicle: transport,
      },
    ]);
  };

  const sendOrderBooking = async () => {
    try {
      const driver = drivers[0] || {};
      const body = {
        driverId: driver.id,
        vehicleId: driver.vehicle?.id,
      };
      await Order.sendOrderBook(getOrder.id, body);
      setIsOpenModal(false);
      toast.success("Водитель успешно назначен");
      fetchOrderData();
      onUpdateData();
    } catch (e) {
      toast.error("Произошла ошибка, попробуйте позже");
      console.log("Ошибка при назначение водителя", e);
    }
  };

  const onDeleteDriver = (driver) => {
    if (isBooked) {
      // onCancelBooking()
    } else {
      setDrivers(drivers.filter((d) => d.id !== driver.id));
    }
  };

  useEffect(() => {
    fetchOrderDataById();
  }, [orderId]);

  return (
    <div className={cn(style.cargo_wrapper)}>
      <div style={{ display: "flex", gap: "16px", width: "100%" }}>
        <CustomButton
          text="Назначить водителя"
          style={{ flex: "1" }}
          onClick={() => {
            setIsOpenModal(true);
          }}
          isLoading={isLoading}
        />
      </div>

      {isOpenModal && (
        <div className={cn("modal-overlay", style.modal)}>
          <div className={style.modal_content}>
            <CloseIconNew
              onClick={() => setIsOpenModal(false)}
              style={{ cursor: "pointer" }}
            />
            <CustomButton
              text="Назначить исполнителя"
              // style={{ flex: "1" }}
              onClick={() => sendOrderBooking()}
              isLoading={isLoading}
              isDisabled={!drivers.length || isBooked}
            />
            {drivers.map((driver, index) => (
              <OrderBookingCard
                key={"driver-id-" + driver.id}
                index={index}
                driver={driver}
                companyId={user?.companyId}
                orderId={orderId}
                onDelete={onDeleteDriver}
                isBooked={isBooked}
                getDataSubmit={getBookData}
              />
            ))}
            <OrderBookingCard
              key={"driver-create"}
              isHide={drivers.length}
              index={drivers.length}
              companyId={user?.companyId}
              orderId={orderId}
              isBooked={isBooked}
              getDataSubmit={getBookData}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignYourDriver;
